var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNauru(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.000976562C7.63259 0.000976562 0.766467 6.42479 0.0612793 14.6097H31.9395C31.2342 6.42479 24.3681 0.000976562 16.0003 0.000976562V0.000976562Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.001C24.3681 32.001 31.2342 25.5771 31.9395 17.3923H0.0612793C0.766467 25.5771 7.63259 32.001 16.0003 32.001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2171 21.5661L11.4242 22.4095L12.3789 24.1458L10.4321 23.7734L10.1854 25.7401L8.82934 24.2936L7.47334 25.7401L7.22665 23.7734L5.27978 24.1458L6.23453 22.4095L4.44165 21.5661L6.23459 20.7228L5.27978 18.9866L7.22659 19.359L7.4734 17.3923L8.82934 18.8387L10.1855 17.3923L10.4321 19.359L12.379 18.9866L11.4243 20.7229L13.2171 21.5661Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNauru);
export default __webpack_public_path__ + "static/media/nauru.d545e7af.svg";
export { ForwardRef as ReactComponent };